module.exports = __webpack_public_path__ + "a12a0b7a62f72a00ca57fbc22616ffb4.woff2";